import { format } from "date-fns";
import { es, enUS } from "date-fns/locale";

const getCurrentLanguage = () => {
  if (typeof window !== 'undefined' && localStorage.getItem('lang')) {
    return localStorage.getItem('lang')
  } else if (typeof window !== 'undefined' && navigator.language) {
    return navigator.language
  }

  return 'en';
};

export const getLocale = () => getCurrentLanguage() === 'en' ? enUS : es

const isSpanishLanguage = (lang) => {
  return lang.startsWith('es');
};

const capitalize = (myString) =>
  `${myString.slice(0, 1).toUpperCase()}${myString.slice(1).toLowerCase()}`;

export function getLocalGMT () {
  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = -offsetMinutes / 60;
  const gmt = `GMT${offsetHours >= 0 ? '+' : ''}${offsetHours}`;

  return gmt
}

export function parseFirstAvailableDate(firstAvailableDate) {
  const [year, month, day] = firstAvailableDate.split('-');
  return new Date(year, month - 1, day);
}

export function formatDate(date, options = {}) {
  const { short = false, lang = getCurrentLanguage() } = options;
  const isSpanish = isSpanishLanguage(lang);
  const locale = isSpanish ? es : enUS;

  const isoDateString = (typeof date === "string") 
    ? date.split("T")[0]
    : date.toISOString().split("T")[0];

  const isostring = `${isoDateString}T12:00:00.000Z`;
  const objDate = new Date(isostring);

  const dayNumber = objDate.getDate();

  if (isSpanish) {
    const dayName = short 
      ? capitalize(format(objDate, "EEEEEE", { locale }))
      : capitalize(format(objDate, "EEEE", { locale }));
    
    const monthName = short
      ? format(objDate, "MMM", { locale }).toLowerCase()
      : format(objDate, "MMMM", { locale }).toLowerCase();

    if (short) {
      return `${dayName} ${dayNumber} ${monthName}.`;
    } else {
      return `${dayName} ${dayNumber} de ${monthName}`;
    }
  } else {
    const dayName = short
      ? capitalize(format(objDate, "EEE", { locale }))
      : capitalize(format(objDate, "EEEE", { locale }));

    const monthName = short
      ? capitalize(format(objDate, "MMM", { locale }))
      : capitalize(format(objDate, "MMMM", { locale }));

    if (short) {
      return `${dayName}, ${monthName} ${dayNumber}`;
    } else {
      return `${dayName} ${monthName} ${dayNumber}`;
    }
  }
}

export function formatHour(time, options = {}) {
  const { lang = getCurrentLanguage() } = options;
  const isSpanish = isSpanishLanguage(lang);
  const locale = isSpanish ? es : enUS;

  if (!time) return "";

  const [hour, minutes = '00'] = time.split(':');
  const timeDate = new Date();
  timeDate.setHours(parseInt(hour, 10));
  timeDate.setMinutes(parseInt(minutes, 10));
  timeDate.setSeconds(0);
  timeDate.setMilliseconds(0);
  
  if (isSpanish) {
    if (minutes && minutes !== '00') {
      return `${format(timeDate, 'HH:mm', { locale })} h`;
    } else {
      return `${format(timeDate, 'H', { locale })} h`;
    }
  } else {
    return format(timeDate, 'HH:mm', { locale });
  }
}
